<script lang="ts">
import type { Group } from "../groups/group";
import LevelInput from "../levelup/LevelInput.svelte";
import AttributeRow from "./AttributeRow.svelte";


let contentToggle = false


export let group: Group;
export let changeFn: () => void;

export function display(flag: boolean){
	contentToggle = flag;
}

function updateLevel(level:number): void{
				group.attribute.level = level 
				changeFn()
}

</script>


<tr class="font-bold">
	<td>
		<a class="hover:text-gray-400"
			on:click={() => contentToggle = !contentToggle}>

			{ contentToggle ? "-" : "+"}
			</a>
	</td>

	<AttributeRow editEnabled={!group.editDisabled} attribute={group.attribute} changeFn={changeFn}></AttributeRow>
	{#if !group.editDisabled}
		<!--

		<LevelInput 
			level={group.attribute.level}
			changeFn={updateLevel} 
			costs={group.costs}>
		</LevelInput>

		-->
	{/if}



</tr>



{#if contentToggle}
	{#each group.attributes as attribute}
		<tr>
			<td></td>
			<AttributeRow editEnabled={true} attribute={attribute} changeFn={changeFn}>
			</AttributeRow>

			<!--
			<LevelInput 
				level={group.attribute.level}
				changeFn={updateLevel} 
				costs={group.costs} >
			</LevelInput>
			-->

		</tr>
	{/each}
{/if}

